import { HttpClient, HttpParams } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { environment } from 'src/environments/environment';

import { ApiResponse } from 'src/app/interface/api-response.interface';
import { OpenIdProfileInterface } from 'src/app/interface/open-id-profile.interface';
import { DepositComponent } from 'src/app/dialog/ledger/deposit/deposit.component';
import {
    UserModel,
    UserModelInterface,
} from 'src/app/interface/user-model.interface';
import { MatTableDataSource } from '@angular/material/table';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { OpenIdService } from 'src/app/service/open-id.service';
import { KeycloakProfile } from 'keycloak-js';
import { WithdrawalComponent } from 'src/app/dialog/ledger/withdrawal/withdrawal.component';

type UserModelResponse = ApiResponse<UserModelInterface>;

@Component({
    selector: 'app-view-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css'],
})
export class UsersComponent implements OnInit {
    @ViewChild(MatPaginator) public paginator?: MatPaginator;

    public userModelsSource = new MatTableDataSource<UserModelInterface>([]);
    public pageSizeOptions = [10, 20, 30];
    public searchValue: string = '';
    public searchValueUpdate = new Subject<string>();

    private cacheModels: UserModelInterface[] = [];
    public notCachedModels: KeycloakProfile[] = [];
    public openIdProfile?: OpenIdProfileInterface;

    public columnHeadings: string[] = [
        'control',
        'email',
        'id',
        'balance',
        'firstName',
        'lastName',
        'member',
        'operator',
        'date_joined',
    ];

    constructor(
        private dialog: MatDialog,
        private httpClient: HttpClient,
        private openIdService: OpenIdService
    ) {
        this.searchValueUpdate
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((searchValue: string) => {
                if (searchValue.length) {
                    this.filterUsers(searchValue);
                    //this.searchOpenId(searchValue);
                } else {
                    this.setUserModelsSource();
                }
            });
    }

    ngOnInit(): void {
        this.openIdService.$userProfile.subscribe((openIdProfile) => {
            this.openIdProfile = openIdProfile;
            this.getUsers();
            //this.getKeycloakUsers();
        });
    }

    public deposit(openIdProfile: OpenIdProfileInterface) {
        const dialogRef = this.dialog.open(DepositComponent, {
            data: {
                openIdProfile: openIdProfile,
                dialogContext: true,
            },
        });
    }

    private filterUsers(searchValue: string) {
        let models = this.cacheModels.filter((model: UserModelInterface) => {
            let re = new RegExp(searchValue, 'i');
            if (re.test(model.email)) return true;
            if (re.test(model.first_name)) return true;
            if (re.test(model.last_name)) return true;
            return false;
        });
        this.setUserModelsSource(models);
    }

    private getUsers(offset: number = 0) {
        if (offset == 0) this.cacheModels = [];

        let params = new HttpParams()
            .set('limit', 10)
            //.set('is_superuser', 'false')
            .set('offset', offset)
            .set('ordering', 'email')
            .set('view', 'operator');

        this.httpClient
            .get<UserModelResponse>('users/', { params: params })
            .subscribe((response: UserModelResponse) => {
                response.results.map((userModel) => {
                    this.cacheModels.push(UserModel.factory(userModel));
                });

                // add to table as soon as received
                this.setUserModelsSource();

                if (response.next) {
                    this.getUsers(this.cacheModels.length);
                }
            });
    }

    private searchOpenId(searchValue: string) {
        this.openIdService
            .searchUsers(searchValue)
            .subscribe((results: KeycloakProfile[]) => {
                this.notCachedModels = [];
                for (let user of results) {
                    let have = this.cacheModels.filter(
                        (cached) => user.id == cached.username
                    );

                    if (have.length == 0) {
                        this.notCachedModels.push(user);
                    }
                }
            });
    }

    private setUserModelsSource(source?: UserModelInterface[]) {
        if (!source) source = this.cacheModels;

        this.userModelsSource = new MatTableDataSource<UserModelInterface>(
            source
        );

        if (this.paginator) {
            this.userModelsSource.paginator = this.paginator;
        }
    }

    public withdrawal(openIdProfile: OpenIdProfileInterface) {
        const dialogRef = this.dialog.open(WithdrawalComponent, {
            data: {
                openIdProfile: openIdProfile,
                dialogContext: true,
            },
        });
    }
}
